import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import HouseForm from '@/features/houses/components/forms/house-form'

export const Route = createFileRoute(
  '/_authenticated/dashboard/houses/new',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-4">
          <Link to="/dashboard/houses">
            <Button size="icon" variant="outline" className="rounded-full">
              <ArrowLeft />
            </Button>
          </Link>
        </div>
        <CardTitle>
          Create A New House
        </CardTitle>
        <CardDescription>
          Use this form to enter a new house into the system
        </CardDescription>
      </CardHeader>
      <CardContent>
        <HouseForm />
      </CardContent>
    </Card>
  )
}
